import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { CssVarsProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
import { appStore } from './app/store/model/store';
import { registerServiceWorker } from './pwa';
import { AppStoreProvider } from './shared/store/model/context';
import { I18nProvider } from './shared/i18n';
import './styles/index.css';
import { appTheme } from '@trust_network/shared/theme';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CssVarsProvider
      theme={appTheme}
      defaultMode="system"
      modeStorageKey="trust_network-color-scheme"
      disableTransitionOnChange
    >
      <CssBaseline />
      <BrowserRouter>
        <AppStoreProvider store={appStore}>
          <I18nProvider>
            <App />
          </I18nProvider>
        </AppStoreProvider>
      </BrowserRouter>
    </CssVarsProvider>
  </React.StrictMode>
);

void registerServiceWorker();
